import React from 'react';
import { compose, branch, renderNothing, mapProps } from 'recompose';

import { connect } from 'react-redux'
 
import showOnAnyRoles from 'containers/Role/Show/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'


import { IconButton } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

const InfoButton = notifyHoc(IconButton)


import Dropdown from './Dropdown/Dropdown'
import '!style-loader!css-loader!./Dropdown/dropdown.css'
import {
  DropdownToggle,
  DropdownMenu,
  DropdownMenuWrapper,
  MenuItem,
  DropdownButton
} from '@trendmicro/react-dropdown';


import {
  updateToggle,
} from '../HulkRequest/actions.js';

import { 
  toggleSelector
} from '../HulkRequest/selectors'

const mapDispatchToProps = (dispatch) => {
  return {
    updateToggle: (toggle) => dispatch(updateToggle(toggle))
  };
}

const mapStateToProps = (state) => {
  return {
    toggle: toggleSelector(state),
    projectSegment: segmentSelector(state)

  }
}

import { segmentSelector  } from 'containers/Project/View/selectors'


class NewDropdown extends React.Component {

    render (){

    const {
        toggle,
        updateToggle
      } = this.props

    return (
      <div>
        <Dropdown style={{marginLeft: '10px', marginTop: '0px', borderRadius: '3px'}}>
                <Dropdown.Toggle  btnStyle="link" style={{textAlign: 'bottom'}}>
                    <i class='material-icons'style={{verticalAlign: 'middle', fontSize: "0.5em", color:'#5f6368'}}>settings </i>
                </Dropdown.Toggle>
                <Dropdown.Menu style={{borderRadius: '5px'}}>
                    <MenuItem eventKey={2} onSelect={() => updateToggle(!toggle)}>HULK Request</MenuItem>
                </Dropdown.Menu>
        </Dropdown>
      </div>
    );
            }
}


const withConnect = connect(mapStateToProps,mapDispatchToProps)

const withRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  showOnAnyRoles,
)



const enhance = compose(
  withConnect,
  withRoles,
  branch(
    ({ projectSegment }) => !['Notebook','Desktop'].includes(projectSegment),
    renderNothing
  ),

  
)

export default enhance(NewDropdown)
